import React from "react";
import TourDetails from "../pages/TourDetails";

// Import Hero Image
import spitiHero from "../assets/Narkanda/Narkanda.png";

// Import Gallery Images
import g1 from "../assets/Narkanda/Narkanda.png";
import g2 from "../assets/Narkanda/Sangla.png";
import g3 from "../assets/Narkanda/Chitkul.png";
import g4 from "../assets/Narkanda/Kalpa.png";
import g5 from "../assets/Narkanda/Kaza.png";
import g6 from "../assets/Narkanda/Chandratal.png";
import g7 from "../assets/Narkanda/Manali.png";
import { useEffect } from "react";

export default function SpitiTour() {
  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <TourDetails
      title="Spiti Valley Tour Package"
      duration="09 Nights / 10 Days"
      includes="Narkanda, Sangla, Chitkul, Kalpa, Tabo, Kaza, Chandratal, Manali"

      heroImage={spitiHero}

      galleryImages={[g1, g2, g3, g4, g5, g6,g7]}

      tourPlan={{
        inclusions: [
          "01 Night Narkanda – Hotel Echor or Similar",
          "02 Nights Sangla – Prakash Regency or Similar",
          "01 Night Kalpa – Hotel Kinner Villa or Similar",
          "01 Night Tabo – Hotel Metrya or Similar",
          "02 Nights Kaza – Hotel Sakya Abode or Similar",
          "01 Night Chandratal – Moon Lake Camp or Similar",
          "01 Night Manali – Manali Heaven or Similar",
          "Daily Breakfast & Dinner",
          "Innova Crysta for complete trip (Chandigarh Pickup & Drop)"
        ],

        days: [
          {
            title: "Day 01: Chandigarh → Narkanda (180 km)",
            points: [
              "Pickup from Chandigarh Airport / Railway Station",
              "Drive to Narkanda",
              "Visit Fagu, Hatu Peak & Tanni Jubbar Lake",
              "Check-in to hotel",
              "Dinner & Overnight stay"
            ],
          },

          {
            title: "Day 02: Narkanda → Sangla (160 km / 6 hrs)",
            points: [
              "Breakfast at hotel",
              "Drive to Sangla – beautiful Baspa valley",
              "Explore forest slopes & Himalayan views",
              "Check-in at hotel",
              "Dinner & Overnight stay"
            ],
          },

          {
            title: "Day 03: Sangla → Chitkul (25 km / 1.5 hrs)",
            points: [
              "Drive to Chitkul – last Indian village",
              "Enjoy Baspa river views",
              "Walk through the village",
              "Return to Sangla",
              "Overnight stay at hotel"
            ],
          },

          {
            title: "Day 04: Sangla → Kalpa (31 km / 6 hrs)",
            points: [
              "Drive to Kalpa",
              "Explore Reckong Peo, Kothi, Jangi, Roghi Village",
              "View Kinner Kailash peaks",
              "Check-in at hotel",
              "Dinner & Overnight"
            ],
          },

          {
            title: "Day 05: Kalpa → Tabo (50 km / 1.5 hrs)",
            points: [
              "Breakfast and drive to Tabo",
              "Visit Dhankar Gompa",
              "Explore Tabo village",
              "Check-in at hotel",
              "Overnight stay"
            ],
          },

          {
            title: "Day 06: Tabo → Kaza",
            points: [
              "Drive to Kaza",
              "Visit Key Monastery",
              "Visit Hikkim, Komic & Langza (highest motorable villages)",
              "Explore Fossil Park",
              "Overnight stay in Kaza"
            ],
          },

          {
            title: "Day 07: Kaza Sightseeing",
            points: [
              "Key Monastery visit",
              "Komic (world’s highest motorable village)",
              "Lunch at Langza",
              "Visit Fossil Park",
              "Return to Kaza for night stay"
            ],
          },

          {
            title: "Day 08: Kaza → Chandratal",
            points: [
              "Drive towards Kunzum Pass",
              "Cross into Lahaul Valley",
              "Reach Chandratal campsite",
              "Evening walk around the turquoise lake",
              "Night stay at camps"
            ],
          },

          {
            title: "Day 09: Chandratal → Manali",
            points: [
              "Start early morning",
              "Drive towards Gramphoo & Batal",
              "Cross Rohtang Pass",
              "Arrive in Manali",
              "Check-in & rest",
              "Overnight stay"
            ],
          },

          {
            title: "Day 10: Manali → Chandigarh (Departure)",
            points: [
              "Checkout from hotel",
              "Drive back to Chandigarh",
              "Drop at Airport / Railway Station",
              "Tour Ends with Beautiful Memories"
            ],
          },
        ],
      }}
    />
  );
}
